import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Play = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5858 7.58195C12.9076 7.76775 12.9076 8.23225 12.5858 8.41805L3.89687 13.4346C3.57506 13.6204 3.17279 13.3882 3.17279 13.0166L3.17279 2.98344C3.17279 2.61184 3.57506 2.37959 3.89687 2.56539L12.5858 7.58195Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Play;
